import React, { useRef } from 'react';

import { IconButton, Popover } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useSectionStandards } from 'sdk';

import { ReactComponent as FilterIcon } from 'pages/Teachers/AssignmentsList/assets/filter-icon.svg';
import { ReactComponent as SearchIcon } from 'pages/Teachers/AssignmentsList/assets/search-icon.svg';

import DateField from 'components/DateField';

import styles from './styles.module.scss';

const AssignmentNavSearch = ({
  query = '',
  sectionId,
  onQueryChange,
  filtersActive = false,
  onToggleFilters,
  standardValue = 'all',
  onStandardChange,
  startDate = null,
  onStartDateChange,
  endDate = null,
  onEndDateChange,
  onResetFilters
}) => {
  const containerRef = useRef(null);

  const { data: standardsData } = useSectionStandards({ sectionId });

  return (
    <div className={styles.searchWrapper} ref={containerRef}>
      <div className={styles.searchInputBar}>
        <IconButton
          className={`${styles.filterBtn} ${
            filtersActive ? styles.filterBtnActive : ''
          }`}
          onClick={onToggleFilters}
          aria-label="Toggle filter settings"
        >
          <FilterIcon className={styles.filterIconSvg} />
        </IconButton>

        <input
          type="text"
          placeholder="Search Assignments or Standards"
          value={query}
          onChange={onQueryChange}
          className={styles.textFieldInput}
        />

        <div className={styles.searchIconIndicator}>
          <SearchIcon className={styles.searchIconSvg} />
        </div>
      </div>

      <Popover
        open={filtersActive}
        anchorEl={containerRef.current}
        onClose={onToggleFilters}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        classes={{
          paper: styles.filterMenuOverlay
        }}
        elevation={4}
      >
        <div className={styles.filterFieldGroup}>
          <label className={styles.fieldLabelText}>Standards</label>
          <Select
            value={standardValue}
            multiple
            onChange={(event) => onStandardChange({ target: event.target })}
            IconComponent={ExpandMoreIcon}
            className={styles.dropdownSelectComponent}
            disableUnderline
            MenuProps={{ disablePortal: true }}
          >
            <MenuItem value="all">All Standards</MenuItem>
            {standardsData?.standards?.map((standard) => (
              <MenuItem key={standard} value={standard}>
                {standard}
              </MenuItem>
            ))}
          </Select>
        </div>

        <div className={styles.filterFieldGroup}>
          <label className={styles.fieldLabelText}>Start Date</label>
          <DateField
            name="startDate"
            disablePast={false}
            placeholder="Choose start date"
            value={startDate || null}
            onChange={onStartDateChange}
          />
        </div>

        <div className={styles.filterFieldGroup}>
          <label className={styles.fieldLabelText}>End Date</label>
          <DateField
            name="endDate"
            disablePast={false}
            placeholder="Choose end date"
            value={endDate || null}
            onChange={onEndDateChange}
          />
        </div>

        <div className={styles.resetActionContainer}>
          <button
            type="button"
            onClick={onResetFilters}
            className={styles.btnResetFilters}
          >
            Reset Filters
          </button>
        </div>
      </Popover>
    </div>
  );
};

export default AssignmentNavSearch;
